import { render, staticRenderFns } from "./CollectionsList.vue?vue&type=template&id=295ed908&"
import script from "./CollectionsList.vue?vue&type=script&lang=ts&"
export * from "./CollectionsList.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionsList.vue?vue&type=style&index=0&id=295ed908&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports